(() => {
  angular
    .module('app.components')
    .directive('checkboxArr', () => {
      return {
        restrict: 'A',
        priority: 10,
        scope: {
          items: '=checkboxArr'
        },
        link: function (scope, ele, attr) {
          const className = ele.data('class') || 'active';
          const value = isNaN(attr.value) ? attr.value : scope.$eval(attr.value);

          ele.bind('click', function () {
            if (scope.items && (scope.items.length != 1 || scope.items[0] != value)) {
              ele.toggleClass(className);
              // this take place before toggle class because the priority
              scope.$apply(function () {
                ele.hasClass(className) ?
                  scope.items.push(value) :
                  scope.items.splice(_.indexOf(scope.items, value), 1);
              });

              ele.closest('.box').find('.checkbox').each(function () {
                if ($(this).hasClass('disabled'))
                $(this).removeClass('disabled');
              });

              if (scope.items.length == 1) {
                ele.closest('.box').find('.checkbox').each(function () {
                  if ($(this).hasClass('checked'))
                  $(this).addClass('disabled');
                });
              }
            }
          });

          scope.$watch('items', function (newv) {
            if (_.isArray(scope.items)) {
              newv = _.indexOf(newv, value) != -1;
            }
            newv ? ele.addClass(className) : ele.removeClass(className);
          });
        }
      }
    }
  );
})();
